// #TODO get some data from this file, or from a similar assets.js / BuildInfo file
// Example of including a random JS file into your bundle.
console.log("foo.js was here")
